import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17.5938 8.6875L17.5547 8.72656C17.6328 8.80469 17.7109 8.92188 17.7109 9.03906C17.7109 9.19531 17.6328 9.27344 17.5547 9.35156L9.3125 17.6328C9.23438 17.7109 9.11719 17.75 9 17.75C8.84375 17.75 8.72656 17.7109 8.64844 17.6328L0.40625 9.39062C0.328125 9.3125 0.289062 9.19531 0.289062 9.03906C0.289062 8.92188 0.328125 8.80469 0.40625 8.6875L0.71875 8.41406C0.796875 8.33594 0.875 8.29688 1.03125 8.29688C1.14844 8.29688 1.26562 8.33594 1.38281 8.41406L8.33594 15.4062V0.71875C8.33594 0.601562 8.375 0.484375 8.45312 0.40625C8.53125 0.328125 8.64844 0.25 8.80469 0.25H9.19531C9.3125 0.25 9.42969 0.328125 9.50781 0.40625C9.58594 0.484375 9.66406 0.601562 9.66406 0.71875V15.4062L16.6172 8.41406C16.6953 8.33594 16.8125 8.29688 16.9688 8.29688C17.0859 8.29688 17.2031 8.33594 17.2812 8.41406L17.5938 8.6875Z",
		fill: "currentColor"
	})
});
export default SvgArrowDown;
